module.exports = __webpack_public_path__ + "img/picto-tab-quicksearch.8f6d3584.svg";